import React from 'react';
import * as Types from '../types';

const withLoadingOnDemand = Component => (
  class withLoadingOnDemandHOC extends React.Component {
    static displayName = `withLoadingOnDemand(${Component.displayName})`

    static defaultProps = Component.defaultProps;

    constructor(props) {
      super(props);
      this.state = {
        items: [],
        total: props.websites.length,
      };
    }

    onLoadItems = (offset, limit, search, type, done) => {
      const { websites } = this.props;
      setTimeout(() => {
        const filteredWebsites = websites.filter(item => (
          (type === Types.all || item.type === type)
          && item.attributes.name.toLowerCase().includes(search)
        ));
        this.setState({
          items: filteredWebsites.slice(0, offset + limit),
          total: filteredWebsites.length,
        });
        done();
      }, 1000);
    };

    render() {
      const { pagination } = this.props;
      const { total, items } = this.state;
      const props = {
        ...this.props,
        websites: items,
        pagination: {
          ...pagination,
          onLoadItems: (...args) => {
            this.onLoadItems(...args);
            pagination.onLoadItems(...args);
          },
          total,
        },
      };

      return (
        <Component {...props} />
      );
    }
  }
);

export default withLoadingOnDemand;
